// Fake body-map values (severity 0–4 per body part) so the configurator can
// render a representative preview before any real athlete data is fetched.
// Keys match the SVG part ids in src/Utils/bodyMapSvg.json (front + back).
export const MOCK_BODY_MAP_DATA: Record<string, Record<string, number>> = {
  "2024-01-15": {
    // front
    neck: 1,
    chest: 0,
    abdomen: 2,
    "shoulder-rt": 3,
    "shoulder-lt": 1,
    "thigh-rt": 4,
    "thigh-lt": 2,
    "knee-rt": 3,
    "leg-lt": 1,
    "forearm-rt": 2,
    // back
    back: 2,
    loin: 3,
    "hamstring-rt": 4,
    "hamstring-lt": 2,
    "calf-rt": 1,
    "calf-lt": 3,
    "shoulder-back-lt": 2,
  },
};
